// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.action-bar-KnnRrN{-moz-column-gap:8px;align-items:center;column-gap:8px;display:flex}.action-bar-KnnRrN .icon-button-oIvN91{color:#060709;font-size:16px}.action-bar-KnnRrN .icon-button-oIvN91.icon-button-active-UjeMf9{background-color:var(--semi-color-fill-1)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"action-bar": `action-bar-KnnRrN`,
	"actionBar": `action-bar-KnnRrN`,
	"icon-button": `icon-button-oIvN91`,
	"iconButton": `icon-button-oIvN91`,
	"icon-button-active": `icon-button-active-UjeMf9`,
	"iconButtonActive": `icon-button-active-UjeMf9`
};
export default ___CSS_LOADER_EXPORT___;
